export interface IPNSJobExecutionRequest {
  jobType: string;
  updatedBy: string;
  notificationEmail: string;
}
